import React, { useEffect } from "react"

import { Tabs, Panel } from "@tenforce/toolbox-tabs-react"
import PageFooter from "./pageFooter/PageFooter"
import { ItemDetailUrlData, parseItemDetailUrl } from "../../../util/Url"
import { useAppDispatch, useAppSelector } from "../../../hooks"
import { GlobalState } from "../../../store"
import { setItemId } from "../../fields/slice"
import { fetchActionButtons, fetchItemDetail } from "../slice"
import { GridField } from "./GridField"
import ItemDetailHeader from "./pageHeader/ItemDetailHeader"
import PanelFooter from "./panelFooter/PanelFooter"

import "./pageHeader/Header.scss"

export default function ItemDetail(): JSX.Element {
    const dispatch = useAppDispatch()
    const itemDetail = useAppSelector((state: GlobalState) => state.itemDetail)

    const initializeItemDetail = async (
        itemDetail: ItemDetailUrlData,
    ): Promise<void> => {
        // The Fields Slice needs the itemId to be set
        dispatch(setItemId(itemDetail.itemId))
        dispatch(fetchItemDetail(itemDetail.itemId))
        dispatch(fetchActionButtons())
    }

    const createTabs = (): JSX.Element[] => {
        return itemDetail.tabs.map((tab, i) => (
            <Panel key={i} panelTitle={tab.label}>
                <div>
                    <div className="tw-grid tw-grid-cols-2">
                        {tab.fields.map((field) => (
                            <GridField key={field.fieldId} field={field} />
                        ))}
                    </div>
                </div>
            </Panel>
        ))
    }

    useEffect(() => {
        initializeItemDetail(parseItemDetailUrl())
    }, [])

    return (
        <>
            <div id="newui-resource-header" className="NewUI">
                <div className=" " style={{ transform: "translateZ(0px)" }}>
                    <ItemDetailHeader />
                </div>
            </div>

            <div id="itemdetailpage" className="item-detail">
                <div className="item-detail-content-panel">
                    <div className="tid-content-wrapper">
                        <Tabs
                            id="tabs"
                            isSeparatorShown={true}
                            separatorExtraClasses={"is-dotted is-dimmed"}
                            isInverted={false}
                            defaultSelectedIndex={0}
                            navigationProps={{
                                extraClasses: "tw-mx-2 tw-p-4",
                            }}
                            navigationItemProps={{ extraClasses: "tw-px-1" }}
                            panelsProps={{ extraClasses: "tw-mb-2 tw-mt-3" }}
                        >
                            {createTabs()}
                        </Tabs>
                    </div>
                    <PanelFooter itemId={itemDetail.item.id} />
                </div>
                <PageFooter />
            </div>
        </>
    )
}
